export default "__VITE_ASSET__DGnAHhUC__"